import { http } from '../common/utils';
import { CLASSTING_API_URL, CLASSTING_APIS_DOMAIN } from '../common/constants';

export const fetchOrgServiceMe = async ({ sid }) => {
  const response = await http.get(
  `${CLASSTING_APIS_DOMAIN}/organization-service/organizations/${sid}/members/me`,
  );
  return response;
};

export const fetchOrgServiceOrg = async ({ sid }) => {
  const response = await http.get(
  `${CLASSTING_APIS_DOMAIN}/organization-service/organizations/${sid}`,
  );
  return response;
};

export const fetchOrgServiceSubscribeFeatures = async ({ sid }) => {
  const response = await http.get(
  `${CLASSTING_APIS_DOMAIN}/organization-service/organizations/${sid}/features`,
  );
  return response;
};

export const fetchAdminApplications = ({ sid }) => http.get(
  `${CLASSTING_API_URL}/v1/admin_applications`,
  { params: { school_id: sid } },
);

export const createAdminAppication = ({
  sid,
  name,
  jobPosition,
  email,
  certFile,
}) => {
  const data = new FormData();

  data.append('name', name);
  data.append('job_position', jobPosition);
  data.append('email', email);
  data.append('cert_file', certFile);

  return http.request({
    method: 'POST',
    url: `${CLASSTING_API_URL}/v1/schools/${sid}/admin_applications`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const fetchSchoolAdminRelationships = ({
  page, perPage, sid,
} = { page: 1, perPage: 10 }) => http.get(`${CLASSTING_API_URL}/v1/schools/${sid}/admin_relationships`, {
  params: { page, per_page: perPage },
});

export const deleteAdminRelationship = ({ id }) => http.delete(`${CLASSTING_API_URL}/v1/admin_relationships/${id}`);
